import { Suspense } from 'react'

import useAccessToken from '@shared/lib/auth/useAccessToken'
import Loader from '@shared/ui/loader/Loader'

import {
    PERSISTENT_SEARCH_PARAMS,
    SESSION_SEARCH_PARAMS,
} from './config/searchParams'
import useCollectSearchParams from './hooks/useCollectSearchParams'
import useThirdParties from './hooks/useThirdParties'
import useGlobalTracker from './libs/amplitude/hooks/useGlobalTracker'
import AppRouter from './routes/AppRouter'
import useAppPersistentStore from './store/useAppPersistentStorage'
import useAppSessionStore from './store/useAppSessionStore'


const App = () => {
    const setSessionSearchParams = useAppSessionStore((state) => state.setSearchParams)
    const setPersistentSearchParams = useAppPersistentStore((state) => state.setSearchParams)
    const sessionSearchParams = useAppSessionStore((state) => state.searchParams)
    const persistentSearchParams = useAppPersistentStore((state) => state.searchParams)

    useCollectSearchParams(SESSION_SEARCH_PARAMS, setSessionSearchParams, sessionSearchParams)
    useCollectSearchParams(PERSISTENT_SEARCH_PARAMS, setPersistentSearchParams, persistentSearchParams)
    useGlobalTracker()
    useThirdParties()
    useAccessToken()

    return (
        <Suspense fallback={ <Loader isFullPage /> }>
            <AppRouter />
        </Suspense>
    )
}

export default App
